var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey2 = function SvgKey2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M44 16.587c0 6.951-5.658 12.587-12.638 12.587-1.274 0-4.174-.293-5.585-1.464l-1.764 1.756c-1.036 1.033-.756 1.337-.295 1.838.192.209.416.452.59.797 0 0 1.469 2.049 0 4.098-.882 1.17-3.351 2.81-6.173 0l-.588.585s1.764 2.05.294 4.099c-.882 1.17-3.233 2.341-5.29.292l-2.058 2.05c-1.41 1.404-3.135.585-3.82 0l-1.764-1.757c-1.646-1.64-.686-3.415 0-4.098l15.284-15.221s-1.47-2.342-1.47-5.562C18.723 9.635 24.381 4 31.362 4S44 9.635 44 16.587m-12.638 4.39c2.435 0 4.409-1.965 4.409-4.39s-1.974-4.39-4.41-4.39c-2.434 0-4.408 1.965-4.408 4.39s1.974 4.39 4.409 4.39",
    clipRule: "evenodd"
  })));
};
export default SvgKey2;